/**
 * AddCommentDialog component
 *
 * A shadcn/ui Dialog wrapping CommentForm, triggered by the "Comment"
 * action button on the issue detail page.
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CommentForm } from "./CommentForm";

interface AddCommentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  issueId: number;
}

export function AddCommentDialog({ open, onOpenChange, issueId }: AddCommentDialogProps) {
  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>Add Comment</DialogTitle>
          <DialogDescription>
            Add a comment to this security issue. Choose a comment type to categorize it.
          </DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto flex-1 min-h-0 p-1">
          <CommentForm issueId={issueId} onSuccess={handleSuccess} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
